/** Lib Imports */
import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

/** Components */
import NotificationDropdown from "./NotificationDropdown";

/** RTK Query */
import { useGetUnreadNotificationCountQuery } from "../../../app/services/notificationApi";

/** Utilities */
import { normalizeUnreadNotificationCount } from "../../../utils/common/notificationDisplay";

/** CSS */
import "./Notifications.scss";

const NotificationBell = (props) => {

  const overlayRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const { data: unreadCountResponse } = useGetUnreadNotificationCountQuery();

  const unreadCount = normalizeUnreadNotificationCount(unreadCountResponse);
  const hasUnreadNotifications = unreadCount > 0;
  const unreadCountLabel = unreadCount > 9 ? "9+" : unreadCount;

  const hideOverlay = () => {
    overlayRef.current?.hide();
    setIsOpen(false);
  };

  return (
    <div className="notification-bell">
      <Button
        outlined
        className={`notification-bell__button ${hasUnreadNotifications ? "notification-bell__button--has-count" : ""
          }`}
        icon="pi pi-bell"
        tooltip="Notifications"
        data-pr-position="bottom"
        aria-label={
          hasUnreadNotifications
            ? `${unreadCount} unread notifications`
            : "Notifications"
        }
        onClick={(event) => overlayRef.current?.toggle(event)}
      >
        {/* <span className="notification-bell__swap" aria-hidden="true">
          <span className="notification-bell__swap-item notification-bell__swap-item--icon">
            <i className="pi pi-bell"></i>
          </span>
          {hasUnreadNotifications && (
            <span className="notification-bell__swap-item notification-bell__swap-item--count">
              {unreadCountLabel}
            </span>
          )}
        </span> */}
      </Button>

      {hasUnreadNotifications && (
        <span className={`notification-bell__badge`}>
          {unreadCountLabel}
        </span>
      )}

      <OverlayPanel
        ref={overlayRef}
        dismissable
        className="notification-overlay-panel"
        onShow={() => setIsOpen(true)}
        onHide={() => setIsOpen(false)}
      >
        <NotificationDropdown visible={isOpen} onRequestClose={hideOverlay} />
      </OverlayPanel>
    </div>
  );
};

export default NotificationBell;
